import styles from "./Instructions.module.scss";
import { FormattedMessage } from "react-intl";
import hasInstructions from "../hasInstructions";
import Attachments from "./Attachments";
import DisplayNotes from "../common/DisplayNotes";
import { CourseMaterial } from "../coursesLoader";

export default function Instructions({
  attachments,
  displayNotes,
}: Pick<CourseMaterial, "attachments" | "displayNotes">) {
  const showInstructions = hasInstructions({
    attachments,
    displayNotes,
  });

  return (
    <>
      {showInstructions ? (
        <div className={styles.container} data-testid="material-instructions">
          <h3 className={styles.containerTitle}>
            <FormattedMessage defaultMessage="Instructions" />
          </h3>

          {displayNotes && (
            <div className={styles.displayNotes}>
              <DisplayNotes displayNotes={displayNotes} />
            </div>
          )}

          {attachments?.length > 0 && <Attachments attachments={attachments} />}
        </div>
      ) : null}
    </>
  );
}
